import styled, { css } from 'styled-components';

export default styled.button.attrs({
  className: 'b-btn--plain',
  type: 'button',
})`
  ${({ theme, customClass, size }) => {
    const { colors, fonts } = theme;
    const buttonSizes = {
      large: '20px 40px',
      medium: '15px 30px',
      small: '10px 20px',
    };

    const defaultColor = colors.primary.gravity;
    const hoverColor = colors.primary.gravity;
    const disabledColor = colors.primary.neutralLight;

    const textColor = customClass?.includes('compare-plans-button-white') ? colors.primary.white : defaultColor;
    const isPmr = customClass?.includes('pmr');
    const pmrFontSize = size === 'small' ? '14px' : '16x';
    return css`
      padding: ${({ size }) => (size ? buttonSizes[size] : buttonSizes.medium)};
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: transparent;
      text-align: left;
      color: ${textColor};
      text-decoration: underline;
      text-decoration-color: ${textColor};
      span {
        font-family: ${fonts.objectSans};
        font-size: ${isPmr ? pmrFontSize : '18px'};
        font-weight: 700;
        line-height: 22px;
        color: ${textColor};
      }
      &:hover {
        text-decoration-color: ${textColor}!important;
      }
      svg {
        width: 24px;
        height: 24px;
        fill: ${textColor};
      }

      ${({ disabled }) =>
        disabled
          ? css`
              color: ${disabledColor};
              cursor: not-allowed;
            `
          : css`
              color: ${defaultColor};

              &:hover {
                color: ${hoverColor};
              }

              &:active {
                transform: scale(0.98);
                color: ${hoverColor};
              }
            `}
    `;
  }};
`;
